import appStore from './appStore.js';

const store = {
  appStore
}
export default store